import React, { useCallback, useEffect } from "react";
import { RouterItemProps, RouterProps } from "@/component/Router/types";
import { RouterStoreItem, RouterStoreItemKey } from "@/store/useRouter/types";
import useRouter from "@/store/useRouter";
import { useShallow } from "zustand/shallow";
import * as style from "@/component/Router/style.scss";
import NotReturnedCard from "../NotReturnedCard/indexOld";
import ReleaseCard from "../ReleaseCard/indexOld";
import StockingCard from "../StockingCard/indexOld";
import Inventory2 from "../Inventory2/indexOld";
import Login from "../Login";
import HistoryItems from "../HistoryItems/historyItemsOP";
import useAppData from "@/store/useAppData";
import ItemListCardOP from "../ItemListCard/itemListCardOP";
import ItemListCardOdmraz from "../ItemListCard/itemListCardOdmraz";
import ChangePassword from "../ChangePassword";
import DeicingForm from "../DeicingForm";
import ItemListDeicing from "../DeicingList";
import DeicingCheckForm from "../DeicingCheck";
import StockingDeicingCard from "../StockingDeicingCard";
import HistoryItemsOdmraz from "../HistoryItems/historyItemsOdmraz";
import SelectModule from "../SelectModule";
import SelectRoleOdmraz from "../SelectRoleOdmraz";
import InventoryDeice from "../InventoryDeice";
import DeicingFormTech from "../DeicingFormTech";

// render a single router item based on its key
export const RouterItem = React.memo((props: RouterItemProps) => {

    const selectedModule = useAppData(state => state.selectedModule);

    switch (props.routerItem.key) {
        case RouterStoreItemKey.LOGIN:
            return <Login></Login>;
        case RouterStoreItemKey.LISTITEMS:
            return selectedModule?.code === "OP" ?
                <ItemListCardOP></ItemListCardOP> :
                <ItemListCardOdmraz></ItemListCardOdmraz>;
        case RouterStoreItemKey.INVENTORY:
            return <Inventory2></Inventory2>;
        case RouterStoreItemKey.INVENTORYDEICE:
            return <InventoryDeice></InventoryDeice>;
        case RouterStoreItemKey.NOTRETURNEDCARD:
            return <NotReturnedCard></NotReturnedCard>;
        case RouterStoreItemKey.RELEASECARD:
            return <ReleaseCard></ReleaseCard>;
        case RouterStoreItemKey.STOCKINGCARD:
            return <StockingCard></StockingCard>;
        case RouterStoreItemKey.STOCKINGDEICINGCARD:
            return <StockingDeicingCard></StockingDeicingCard>;
        case RouterStoreItemKey.HISTORYITEMS:
            return <HistoryItems></HistoryItems>;
        case RouterStoreItemKey.HISTORYITEMSODMRAZ:
            return <HistoryItemsOdmraz></HistoryItemsOdmraz>;
        case RouterStoreItemKey.CHANGEPASSWORD:
            return <ChangePassword></ChangePassword>;
        case RouterStoreItemKey.DEICINGCARD:
            return <DeicingForm operationCode={props.routerItem?.data?.code ?? null}></DeicingForm>;
        case RouterStoreItemKey.DEICINGCARDTECH:
            return <DeicingFormTech></DeicingFormTech>;
        case RouterStoreItemKey.DEICINGCHECKCARD:
            return <DeicingCheckForm></DeicingCheckForm>;
        case RouterStoreItemKey.SELECTMODULE:
            return <SelectModule></SelectModule>;
        case RouterStoreItemKey.SELECTROLE:
            return <SelectRoleOdmraz></SelectRoleOdmraz>;
        // case RouterStoreItemKey.DEICINGLIST:
        //     return <ItemListDeicing></ItemListDeicing>;
        default:
            return <></>;
    }
});

// main router component
export const Router = React.memo((props: RouterProps) => {
    const router = useRouter(
        useShallow(state => ({
            go: state.go,
            history: state.history
        }))
    );

    // whenever the router history changes
    useEffect(
        () => {
            if (router.history.length === 0) {
                // there is no page in the history, go to the default page
                router.go({ key: RouterStoreItemKey.LOGIN });
            }
        },
        [router.history.length]
    )

    // render a single router item
    const renderRouterItem = useCallback(
        (item: RouterStoreItem) => {
            return (
                <div
                    key={item.uid}
                    className={
                        item.active ?
                            style.active :
                            style.inactive
                    }
                >
                    <RouterItem routerItem={item} />
                </div>
            );
        },
        [router.history]
    )

    return (
        <>
            {router.history.map(renderRouterItem)}
        </>
    )
});

export default Router;